import { render, staticRenderFns } from "./message-circle.vue?vue&type=template&id=7ff72168"
import script from "./message-circle.vue?vue&type=script&lang=js"
export * from "./message-circle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports